var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddTrainingOfTheDay.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-429f3e62!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddTrainingOfTheDay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/AddTrainingOfTheDay.vue
// module id = 669
// module chunks = 0